<template>
  <footer>
    <p>

    </p>
    <p>雷电云手机© 2022长沙雷电云网络科技有限公司 版权所有</p>
    <p>湖南省长沙市开福区马栏山视频文创产业园兴旺V视界A座1101湘ICP备2021019234号</p>
    <p>雷电云手机 版权所有</p>
    <div>
      <a href="https://www.ldyuncs.com/ldy/customer-xuke.html">用户协议</a> I
      <a href="https://www.ldyuncs.com/ldy/yinsi-zhengce.html">隐私政策</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterNav",
};
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  // min-width: 1200px;
  // height: changeVw(100);
  background: #f5f5f5;
  margin: 0 auto;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: changeVw(28) 0;
  font-size: changeVw(12);
  color: #b3b3b3;
  p {
    text-align: center;
    line-height: 15px;
    a {
      color: #b3b3b3;
    }
  }
  div {
    text-align: center;
    line-height: 15px;
    a {
      text-decoration: none;
      color: #b3b3b3;
    }
  }
}
</style>
